// import { motion } from "framer-motion";
// import {
//   Globe,
//   Headphones,
//   CheckCircle2,
//   ArrowRight,
//   Zap,
//   Lock,
// } from "lucide-react";

// export default function TranscriptionPage() {
//   const features = [
//     {
//       icon: Globe,
//       title: "50+ Languages",
//       desc: "Professional transcription in major world languages",
//     },
//     {
//       icon: Headphones,
//       title: "Native Speakers",
//       desc: "Verified native speaker transcribers",
//     },
//     {
//       icon: Zap,
//       title: "Real-time Processing",
//       desc: "Fast turnaround without quality compromise",
//     },
//     {
//       icon: Lock,
//       title: "Secure & Compliant",
//       desc: "ISO certified, GDPR compliant services",
//     },
//   ];

//   const languages = [
//     "English",
//     "Spanish",
//     "French",
//     "German",
//     "Chinese (Mandarin)",
//     "Chinese (Cantonese)",
//     "Japanese",
//     "Korean",
//     "Arabic",
//     "Hindi",
//     "Portuguese",
//     "Russian",
//     "Italian",
//     "Dutch",
//     "Polish",
//     "Turkish",
//     "Thai",
//     "Vietnamese",
//     "Filipino",
//     "Indonesian",
//   ];

//   return (
//     <main style={{ backgroundColor: "#ffffff" }}>
//       {/* Hero Section - Professional */}
//       <section
//         style={{
//           background: `
//       linear-gradient(
//         rgba(0, 0, 0, 0.72),
//         rgba(0, 0, 0, 0.72)
//       ),
//       url('https://images.unsplash.com/photo-1590650153855-d9e808231d41?w=1920&q=80')
//     `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "1280px",
//             margin: "0 auto",
//             padding: "75px 20px", // 🔑 reduced height
//             color: "white",
//           }}
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 16 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.55 }}
//             style={{ maxWidth: "720px" }}
//           >
//             {/* Badge */}
//             <div
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 marginBottom: "16px",
//                 background: "rgba(59,130,246,0.14)",
//                 border: "1px solid rgba(59,130,246,0.35)",
//                 padding: "8px 14px",
//                 borderRadius: "6px",
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: "12px",
//                   fontWeight: 600,
//                   letterSpacing: "1px",
//                   color: "#93c5fd",
//                 }}
//               >
//                 PROFESSIONAL LANGUAGE SERVICES
//               </span>
//             </div>

//             {/* Title */}
//             <h1
//               style={{
//                 fontSize: "44px", // 🔽 reduced
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 lineHeight: "1.15",
//                 letterSpacing: "-0.4px",
//               }}
//             >
//               Multi-Linguistic Transcription & Translation Services
//             </h1>

//             {/* Description */}
//             <p
//               style={{
//                 fontSize: "16px", // 🔽 reduced
//                 maxWidth: "600px",
//                 opacity: 0.95,
//                 lineHeight: "1.55",
//                 marginBottom: "26px",
//                 color: "#cbd5e1",
//               }}
//             >
//               Accurate transcription and professional translation across 50+
//               languages, powered by AI quality checks and native-speaker
//               verification.
//             </p>

//             {/* Actions */}
//             <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
//               <button
//                 style={{
//                   background: "#3b82f6",
//                   color: "white",
//                   padding: "13px 28px", // 🔽 reduced
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "none",
//                   cursor: "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                 }}
//               >
//                 Get Started <ArrowRight size={16} />
//               </button>

//               <button
//                 style={{
//                   background: "transparent",
//                   color: "white",
//                   padding: "13px 28px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "1.5px solid rgba(255,255,255,0.35)",
//                   cursor: "pointer",
//                 }}
//               >
//                 View Pricing
//               </button>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* Features Grid */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Why Choose Our Service
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "24px",
//             }}
//           >
//             {features.map((feature, index) => {
//               const Icon = feature.icon;
//               return (
//                 <motion.div
//                   key={index}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: index * 0.1 }}
//                   style={{
//                     backgroundColor: "#ffffff",
//                     borderLeft: "3px solid #3b82f6",
//                     padding: "28px",
//                     borderRadius: "8px",
//                     boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                   }}
//                 >
//                   <div
//                     style={{
//                       backgroundColor: "#eff6ff",
//                       width: "48px",
//                       height: "48px",
//                       borderRadius: "8px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginBottom: "16px",
//                     }}
//                   >
//                     <Icon size={24} style={{ color: "#3b82f6" }} />
//                   </div>
//                   <h3
//                     style={{
//                       fontSize: "18px",
//                       fontWeight: "700",
//                       marginBottom: "8px",
//                       color: "#1a202c",
//                     }}
//                   >
//                     {feature.title}
//                   </h3>
//                   <p
//                     style={{
//                       color: "#64748b",
//                       fontSize: "14px",
//                       lineHeight: "1.6",
//                     }}
//                   >
//                     {feature.desc}
//                   </p>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Services Overview */}
//       <section style={{ backgroundColor: "#ffffff", padding: "80px 20px" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Our Service Offerings
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//               gap: "32px",
//             }}
//           >
//             {/* Transcription */}
//             <motion.div
//               initial={{ opacity: 0 }}
//               whileInView={{ opacity: 1 }}
//               transition={{ duration: 0.6 }}
//               style={{
//                 backgroundColor: "#ffffff",
//                 padding: "32px",
//                 borderRadius: "8px",
//                 boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                 border: "1px solid #e5e7eb",
//               }}
//             >
//               <div
//                 style={{
//                   backgroundColor: "#3b82f6",
//                   color: "white",
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "8px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <Headphones size={24} />
//               </div>
//               <h3
//                 style={{
//                   fontSize: "20px",
//                   fontWeight: "700",
//                   marginBottom: "12px",
//                   color: "#1a202c",
//                 }}
//               >
//                 Transcription Services
//               </h3>
//               <p
//                 style={{
//                   color: "#64748b",
//                   marginBottom: "20px",
//                   fontSize: "14px",
//                   lineHeight: "1.6",
//                 }}
//               >
//                 Convert your audio and video files to accurate text
//                 transcriptions in multiple languages
//               </p>
//               <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
//                 {[
//                   "Verbatim transcription",
//                   "Edited transcription",
//                   "Timestamp inclusion",
//                   "Speaker identification",
//                 ].map((item, i) => (
//                   <li
//                     key={i}
//                     style={{
//                       display: "flex",
//                       gap: "12px",
//                       marginBottom: "12px",
//                       alignItems: "flex-start",
//                     }}
//                   >
//                     <CheckCircle2
//                       size={18}
//                       style={{
//                         color: "#3b82f6",
//                         flexShrink: 0,
//                         marginTop: "2px",
//                       }}
//                     />
//                     <span style={{ color: "#475569", fontSize: "14px" }}>
//                       {item}
//                     </span>
//                   </li>
//                 ))}
//               </ul>
//             </motion.div>

//             {/* Translation */}
//             <motion.div
//               initial={{ opacity: 0 }}
//               whileInView={{ opacity: 1 }}
//               transition={{ duration: 0.6, delay: 0.2 }}
//               style={{
//                 backgroundColor: "#ffffff",
//                 padding: "32px",
//                 borderRadius: "8px",
//                 boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                 border: "1px solid #e5e7eb",
//               }}
//             >
//               <div
//                 style={{
//                   backgroundColor: "#0ea5e9",
//                   color: "white",
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "8px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <Globe size={24} />
//               </div>
//               <h3
//                 style={{
//                   fontSize: "20px",
//                   fontWeight: "700",
//                   marginBottom: "12px",
//                   color: "#1a202c",
//                 }}
//               >
//                 Translation Services
//               </h3>
//               <p
//                 style={{
//                   color: "#64748b",
//                   marginBottom: "20px",
//                   fontSize: "14px",
//                   lineHeight: "1.6",
//                 }}
//               >
//                 Professional translation of transcribed content with cultural
//                 adaptation and quality assurance
//               </p>
//               <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
//                 {[
//                   "Human translation",
//                   "Localization services",
//                   "Cultural adaptation",
//                   "Multi-lingual delivery",
//                 ].map((item, i) => (
//                   <li
//                     key={i}
//                     style={{
//                       display: "flex",
//                       gap: "12px",
//                       marginBottom: "12px",
//                       alignItems: "flex-start",
//                     }}
//                   >
//                     <CheckCircle2
//                       size={18}
//                       style={{
//                         color: "#0ea5e9",
//                         flexShrink: 0,
//                         marginTop: "2px",
//                       }}
//                     />
//                     <span style={{ color: "#475569", fontSize: "14px" }}>
//                       {item}
//                     </span>
//                   </li>
//                 ))}
//               </ul>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Languages */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "40px",
//               color: "#1a202c",
//             }}
//           >
//             Supported Languages
//           </h2>
//           <div
//             style={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: "12px",
//               justifyContent: "center",
//             }}
//           >
//             {languages.map((lang, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ duration: 0.3, delay: index * 0.03 }}
//                 style={{
//                   backgroundColor: "#3b82f6",
//                   color: "white",
//                   padding: "10px 20px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "13px",
//                 }}
//               >
//                 {lang}
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Process */}
//       <section style={{ backgroundColor: "#ffffff", padding: "80px 20px" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Our Process
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
//               gap: "32px",
//             }}
//           >
//             {[
//               {
//                 num: "01",
//                 title: "Upload",
//                 desc: "Submit your audio/video files securely",
//               },
//               {
//                 num: "02",
//                 title: "Process",
//                 desc: "AI-assisted transcription processing",
//               },
//               {
//                 num: "03",
//                 title: "Review",
//                 desc: "Human quality assurance and verification",
//               },
//               {
//                 num: "04",
//                 title: "Deliver",
//                 desc: "Download formatted transcriptions",
//               },
//             ].map((step, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 style={{ textAlign: "center" }}
//               >
//                 <div
//                   style={{
//                     backgroundColor: "#3b82f6",
//                     color: "white",
//                     fontSize: "24px",
//                     fontWeight: "700",
//                     marginBottom: "16px",
//                     borderRadius: "50%",
//                     width: "56px",
//                     height: "56px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     margin: "0 auto 16px",
//                   }}
//                 >
//                   {step.num}
//                 </div>
//                 <h3
//                   style={{
//                     fontSize: "18px",
//                     fontWeight: "700",
//                     marginBottom: "8px",
//                     color: "#1a202c",
//                   }}
//                 >
//                   {step.title}
//                 </h3>
//                 <p
//                   style={{
//                     color: "#64748b",
//                     fontSize: "14px",
//                     lineHeight: "1.6",
//                   }}
//                 >
//                   {step.desc}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA - Professional */}
//       <section
//         style={{
//           backgroundColor: "#1e293b",
//           padding: "80px 20px",
//           color: "white",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "800px",
//             margin: "0 auto",
//             textAlign: "center",
//             padding: "0 20px",
//           }}
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             <h2
//               style={{
//                 fontSize: "36px",
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 letterSpacing: "-0.5px",
//               }}
//             >
//               Ready to Get Started?
//             </h2>
//             <p
//               style={{
//                 fontSize: "16px",
//                 color: "#cbd5e1",
//                 marginBottom: "32px",
//                 lineHeight: "1.6",
//               }}
//             >
//               Contact us for a quote or to discuss your transcription and
//               translation needs with our team of experts.
//             </p>
//             <div
//               style={{
//                 display: "flex",
//                 gap: "16px",
//                 justifyContent: "center",
//                 flexWrap: "wrap",
//               }}
//             >
//               <button
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   backgroundColor: "#3b82f6",
//                   color: "white",
//                   padding: "14px 32px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "15px",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Contact Us <ArrowRight size={18} />
//               </button>
//               <button
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   backgroundColor: "transparent",
//                   color: "white",
//                   padding: "14px 32px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "15px",
//                   border: "2px solid rgba(255, 255, 255, 0.2)",
//                   cursor: "pointer",
//                 }}
//               >
//                 Get a Quote
//               </button>
//             </div>
//           </motion.div>
//         </div>
//       </section>
//     </main>
//   );
// }

import { motion } from "framer-motion";
import {
  Globe,
  Headphones,
  CheckCircle2,
  ArrowRight,
  Zap,
  Lock,
  Languages,
  Mic2,
  ShieldCheck,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function TranscriptionPage() {
  const features = [
    {
      icon: Globe,
      title: "50+ Global Dialects",
      desc: "Expert coverage across major world languages and regional nuances.",
    },
    {
      icon: Headphones,
      title: "Native Verification",
      desc: "Every output is verified by certified native-speaker linguists.",
    },
    {
      icon: Zap,
      title: "Rapid Orchestration",
      desc: "High-velocity processing tailored for time-sensitive enterprise needs.",
    },
    {
      icon: Lock,
      title: "Compliance Secure",
      desc: "Hardened data handling protocols including GDPR and ISO standards.",
    },
  ];

  const languages = [
    "English",
    "Spanish",
    "French",
    "German",
    "Mandarin",
    "Japanese",
    "Korean",
    "Arabic",
    "Hindi",
    "Portuguese",
    "Russian",
    "Italian",
    "Dutch",
    "Thai",
    "Vietnamese",
  ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1590650153855-d9e808231d41?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Linguistic Excellence
            </div>
            {/* Mentioned Transcription & Translation explicitly in title */}
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise{" "}
              <span className="text-indigo-400">
                Transcription & Translation
              </span>{" "}
              Ecosystems.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              Accurate transcription and translation services powered by expert
              linguists and enterprise-level quality standards.
            </p>

            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Get Started <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= CORE CAPABILITIES ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16 text-left">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3 text-left">
              Service Standards
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight text-left">
              Professional Language Solutions
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 text-left">
            {features.map((item, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-100 bg-white hover:border-indigo-100 hover:shadow-xl transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6">
                  <item.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= SERVICE OFFERINGS (BENTO BLOCK) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6 text-left">
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Transcription Block */}
            <motion.div
              {...fadeUp}
              className="bg-white p-10 rounded-3xl border border-slate-200 shadow-sm relative overflow-hidden group"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-50 group-hover:bg-indigo-100 transition-colors rounded-bl-full -mr-16 -mt-16" />
              <Mic2 className="text-indigo-600 mb-6 relative z-10" size={32} />
              <h3 className="text-2xl font-bold text-slate-900 mb-4 tracking-tight text-left">
                Transcription Engineering
              </h3>
              <p className="text-slate-500 font-light text-sm mb-8 leading-relaxed text-left">
                Convert complex audio and video assets into structured, accurate
                text with native-speaker oversight.
              </p>
              <ul className="grid sm:grid-cols-2 gap-3 text-left">
                {[
                  "Verbatim Protocols",
                  "Timestamp Integration",
                  "Speaker Diarization",
                  "Multi-Pass QA",
                ].map((f) => (
                  <li
                    key={f}
                    className="flex items-center gap-2 text-xs font-semibold text-slate-700"
                  >
                    <CheckCircle2 size={14} className="text-indigo-600" /> {f}
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Translation Block */}
            <motion.div
              {...fadeUp}
              transition={{ delay: 0.2 }}
              className="bg-[#0f172a] p-10 rounded-3xl text-white relative overflow-hidden group"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full -mr-16 -mt-16" />
              <Languages
                className="text-indigo-400 mb-6 relative z-10"
                size={32}
              />
              <h3 className="text-2xl font-bold mb-4 tracking-tight text-white text-left">
                Global Localization
              </h3>
              <p className="text-slate-400 font-light text-sm mb-8 leading-relaxed text-left">
                Professional translation services with deep cultural adaptation
                for 50+ languages.
              </p>
              <ul className="grid sm:grid-cols-2 gap-3 text-left">
                {[
                  "Native Transcreation",
                  "Regional Localization",
                  "Technical Adaptation",
                  "Consensus Review",
                ].map((f) => (
                  <li
                    key={f}
                    className="flex items-center gap-2 text-xs font-medium text-slate-300"
                  >
                    <CheckCircle2 size={14} className="text-indigo-400" /> {f}
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= SUPPORTED LANGUAGES (MINIMALIST) ================= */}
      <section className="py-24 bg-white text-center">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-slate-900 tracking-tight mb-12">
            Linguistic Reach
          </h2>
          <div className="flex flex-wrap justify-center gap-3">
            {languages.map((lang, i) => (
              <span
                key={i}
                className="px-5 py-2 bg-slate-50 border border-slate-100 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:border-indigo-100 hover:text-indigo-600 transition-all cursor-default"
              >
                {lang}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden border-t border-white/5 text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight text-center">
            Ready for Global Scaling?
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto text-center">
            Build linguistic accuracy into your project. Discuss your
            transcription and translation requirements with our technical lead
            today.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-10 py-3 rounded-xl font-bold text-sm hover:bg-indigo-50 transition-all shadow-xl"
            >
              Consult Data Expert
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}